var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4761 23.5077C38.3152 23.6673 38.1876 23.8571 38.1004 24.0663C38.0133 24.2755 37.9684 24.4998 37.9684 24.7264C37.9684 24.953 38.0133 25.1774 38.1004 25.3865C38.1876 25.5957 38.3152 25.7855 38.4761 25.9451L46.3718 33.8408H5.96646C5.51122 33.8408 5.07464 34.0216 4.75274 34.3435C4.43084 34.6654 4.25 35.102 4.25 35.5572C4.25 36.0125 4.43084 36.4491 4.75274 36.771C5.07464 37.0929 5.51122 37.2737 5.96646 37.2737H46.3375L38.4761 45.1179C38.1564 45.4395 37.977 45.8745 37.977 46.328C37.977 46.7815 38.1564 47.2165 38.4761 47.5381C38.7977 47.8578 39.2328 48.0372 39.6862 48.0372C40.1397 48.0372 40.5747 47.8578 40.8963 47.5381L51.813 36.6214C51.9599 36.4805 52.0768 36.3112 52.1567 36.1239C52.2366 35.9366 52.2777 35.7351 52.2777 35.5315C52.2777 35.3279 52.2366 35.1264 52.1567 34.939C52.0768 34.7517 51.9599 34.5825 51.813 34.4415L40.9135 23.5077C40.7539 23.3468 40.5641 23.2191 40.3549 23.132C40.1458 23.0449 39.9214 23 39.6948 23C39.4682 23 39.2439 23.0449 39.0347 23.132C38.8255 23.2191 38.6357 23.3468 38.4761 23.5077Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowWhite);
export default __webpack_public_path__ + "static/media/right-arrow-white.830c307de227e8d9a02287e5c4fbc7a8.svg";
export { ForwardRef as ReactComponent };